export default __webpack_public_path__ + "static/media/BH.e2b46cb8.svg";